<template>
  <section class="video container smallSectionMargins" :class="{'isPlaying': isPlaying}">
    <div>
      <div class="video__OverlayImage">
        <Flare :srcset="data.image" width="1400" :alt="data.image.alt" />
      </div>
  
      <client-only>
        <YouTube ref="video" class="youtube" :src="data.video_id" :vars="videoControls" @state-change="videoStateChange" />
      </client-only>

      <button class="video__PlayButton" @click="toggleVideoState">
        <Icon name="play" />
      </button>
    </div>
  </section>
</template>

<script setup>
  import YouTube from 'vue3-youtube'
  defineProps({
    data: {}
  })

  const video = ref(null);
  const isPlaying = ref(false);

  const videoControls = {
    controls: 1,
    playsinline: false,
    rel: 0,
  }

  function toggleVideoState() {
    console.log(video.value)
    isPlaying.value = !isPlaying.value
    video.value[isPlaying.value ? 'playVideo' : 'pauseVideo']();
    if(!video.value.initiated) video.value.initPlayer();
  }

  function videoStateChange(e) {
    if (e.data === 1) isPlaying.value = true
    else if (e.data === 2) isPlaying.value = false
  }
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_video.scss');
</style>